import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

export interface FooterProps {
  variant: "light" | "dark";
}

export const Footer = ({ variant }: FooterProps) => {
  const { t } = useTranslation("common");
  const textColor =
    variant === "light" ? "text-muted-foreground" : "text-white/60";

  return (
    <footer className="mt-auto flex flex-row justify-center gap-3">
      <span className={cn("text-xs", textColor)}>{t("footer.poweredBy")}</span>
      <span className={cn("text-xs", textColor)}>|</span>
      <span className={cn("text-xs", textColor)}>{t("footer.rightsReserved")}</span>
    </footer>
  );
};
